import React from 'react';
import { Animated } from 'react-native';
import Column from './Column';
const ColumnCenter = React.forwardRef((props, ref) => React.createElement(Column, { xAxis: "center", yAxis: "center", ref: ref, ...props }));
export default ColumnCenter;
export const AnimatedColumnCenter = Animated.createAnimatedComponent(ColumnCenter);
